namespace GeniuzPOS.Member {
    export interface MbReport_01_Dt_PluForm {
        ShopId: Serenity.StringEditor;
        ShopName: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        NetSales: Serenity.DecimalEditor;
        DtList: MbReport_01_Dt_Editor;
    }

    export class MbReport_01_Dt_PluForm extends Serenity.PrefixedContext {
        static formKey = 'Member.MbReport_01_Dt_Plu';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MbReport_01_Dt_PluForm.init)  {
                MbReport_01_Dt_PluForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;
                var w3 = MbReport_01_Dt_Editor;

                Q.initFormType(MbReport_01_Dt_PluForm, [
                    'ShopId', w0,
                    'ShopName', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'NetSales', w2,
                    'DtList', w3
                ]);
            }
        }
    }
}
